import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { Task } from "@recobra/schemas/task";
import { Badge } from "@recobra/ui/badge";

import { taskDeadlineUrgency } from "./taskDeadlineUrgency";

/** How soon an open task's end deadline is due; nothing once it is done or while the deadline is still far. */
export const TaskDeadlineBadge: FC<{ task: Pick<Task, "status" | "deadlineDate"> }> = ({
  task,
}) => {
  const urgency = taskDeadlineUrgency(task, new Date());
  if (!urgency) return null;

  if (urgency.level === "overdue") {
    return <Badge variant="destructive">{m.task_deadline_overdue({ count: urgency.days })}</Badge>;
  }

  if (urgency.level === "today") {
    return <Badge variant="warning">{m.task_deadline_due_today()}</Badge>;
  }

  return <Badge variant="warning">{m.task_deadline_due_soon({ count: urgency.days })}</Badge>;
};
